import { z } from 'zod';
import { paginationQuerySchema } from '../common/pagination.js';
import { currencyCodeSchema } from '../common/primitives.js';
/**
 * Currencies (cash-deposits.md section 10, SRS SET-02): a local list without
 * exchange prices. Disabling a currency blocks new deposits only (SET-05).
 * `code` cannot change once a deposit uses the currency (CURRENCY_IN_USE).
 * Every currency uses five decimal places (decision D14), so there is no
 * decimals field.
 */
export const recordStatusSchema = z.enum(['ACTIVE', 'INACTIVE']);
export const createCurrencySchema = z.object({
    nameAr: z.string().trim().min(1).max(100),
    nameEn: z.string().trim().min(1).max(100),
    code: currencyCodeSchema,
    status: recordStatusSchema.default('ACTIVE'),
});
export const updateCurrencySchema = createCurrencySchema.omit({ status: true }).partial();
export const changeCurrencyStatusSchema = z.object({ status: recordStatusSchema });
export const currencyListQuerySchema = paginationQuerySchema.extend({
    status: recordStatusSchema.optional(),
});
export const currencyViewSchema = z.object({
    id: z.string(),
    code: z.string(),
    nameAr: z.string(),
    nameEn: z.string(),
    status: recordStatusSchema,
    /** True once a deposit uses it: code is then locked. */
    inUse: z.boolean(),
    createdAt: z.iso.datetime({ offset: true }),
    updatedAt: z.iso.datetime({ offset: true }),
});
/** GET /currencies/options: active currencies for forms and filters. */
export const currencyOptionsQuerySchema = z.object({
    /** Include disabled currencies (for list and report filters). */
    includeInactive: z
        .enum(['true', 'false'])
        .optional()
        .transform((value) => value === 'true'),
});
export const currencyOptionSchema = currencyViewSchema.pick({
    id: true,
    code: true,
    nameAr: true,
    nameEn: true,
    status: true,
});
//# sourceMappingURL=contract.js.map